module.exports = __webpack_public_path__ + "static/img/touxiang02.2c33e1e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/touxiang02.jpg
// module id = SOAF
// module chunks = 4